/**
 * =========================
 * OEMデータ読み込み
 *  新規のOEMを追加する場合
 *  oemディレクトリ配下に任意の名前でフォルダを設定し、
 *  index.jsを作成するだけで自動読み込みする仕組み
 * =========================
 */
const modules = require.context('./', true, /index\.js$/)

const allConfigs = {}

modules.keys().forEach(key => {
  if (key === './index.js') return

  const path = key.replace('./', '').replace('/index.js', '')
  allConfigs[path] = modules(key).default
})

/**
 * =========================
 * SITE_FLAG フィルタリング
 * =========================
 */
const SITE_OEM = process.env.VUE_APP_SITE_OEM

let oemConfigs = {}

if (SITE_OEM && allConfigs[SITE_OEM]) {
  oemConfigs[SITE_OEM] = allConfigs[SITE_OEM]
} else {
  oemConfigs = allConfigs
}

export default oemConfigs
